import React from "react";

function BreadCrumb({ title, text, bgImage }) {
  return (
    <section
      id="breadcrumb"
      className="breadcrumb-container"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="breadcrumb-div">
        <div className="content text-center">
          <h1 className="text-uppercase">{title}</h1>
          <p className="fw-medium text-capitalize">{text}</p>
        </div>
      </div>
    </section>
  );
}

export default BreadCrumb;
